import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=9fa40312&"
import script from "./dropdown-menu.vue?vue&type=script&lang=js&"
export * from "./dropdown-menu.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-menu.vue?vue&type=style&index=0&id=9fa40312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports